export const WebhookV1Payload = class {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "event",
            "baseName": "event",
            "type": "WebhookV1AuditEvent",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1PayloadTypeEnum",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1Payload.attributeTypeMap;
    }
    constructor() {
    }
};
export var WebhookV1PayloadTypeEnum;
(function (WebhookV1PayloadTypeEnum) {
    WebhookV1PayloadTypeEnum["Onboarding"] = "onboarding";
})(WebhookV1PayloadTypeEnum || (WebhookV1PayloadTypeEnum = {}));
